module.exports = __webpack_public_path__ + "img/mall-product-image.e7df70e0.png";